import { FaCheck } from "react-icons/fa";
import { FiMoreHorizontal } from "react-icons/fi";
import styled from "styled-components";

import NoNameIcon from "../../assets/no-name-avatar.svg";
import ToolTip from "../ToolTip";
import FlexBox from "./FlexBox";
import { H3, Support } from "./Headings";
import {
  DAVYS_GREY_100,
  DUSTY_ORANGE_700,
  ERROR_RED_400,
  MOSS_GREEN_800,
} from "./colors";

const Container = styled(FlexBox)`
  position: relative;
  filter: ${({ isDisabled }) => (isDisabled ? "grayscale(1)" : "none")};
  cursor: ${({ isDisabled, onClick }) =>
    onClick && !isDisabled ? "pointer" : "default"};
  width: fit-content;
  height: fit-content;
`;

const Wrapper = styled.div`
  box-sizing: border-box;
  display: flex;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  padding: 0.625rem 0.5rem;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  flex-shrink: 0;
  border-radius: 50%;
  background: linear-gradient(135deg, #fff 0%, #000 100%), #ffefb0;
  background-blend-mode: soft-light, normal;
`;

const initialsfontSizes = {
  // size: font-size
  "2rem": "0.75rem",
  "3rem": "1.125rem",
  "3.75rem": "1.5rem",
};

const Initials = styled(H3)`
  display: flex;
  flex-direction: column;
  align-self: stretch;
  color: ${DUSTY_ORANGE_700};
  text-align: center;
  font-size: 1.125rem;
  font-size: ${({ size }) => initialsfontSizes[size]};
  font-style: normal;
  font-weight: 700;
  line-height: 1.75rem;
  text-transform: uppercase;
`;

const Dot = styled.div`
  position: absolute;
  width: 0.5rem;
  height: 0.5rem;
  top: 0.25rem;
  right: 0.25rem;
  border-radius: 4rem;
  background-color: ${ERROR_RED_400};
`;

const Checkmark = styled(FlexBox)`
  position: absolute;
  width: 1rem;
  height: 1rem;
  bottom: 0;
  right: 0;
  border-radius: 50%;
  background-color: ${MOSS_GREEN_800};
  justify-content: center;
  align-items: center;
`;

const Img = styled.img`
  flex-shrink: 0;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
`;

const Avatar = ({
  name,
  firstname,
  lastname,
  typing,
  showDot,
  showCheckmark,
  isDisabled,
  size = "3rem",
  onClick,
}) => {
  let initials = "";
  const noName = !name && !firstname;
  if (name) {
    initials = name
      .split(" ")
      .map(part => part.charAt(0))
      .join("")
      .slice(0, 2);
  } else if (firstname) {
    initials = `${firstname?.charAt(0)}${
      !!lastname ? lastname?.charAt(0) : ""
    }`;
  }

  return (
    <Container
      onClick={isDisabled ? undefined : onClick}
      isDisabled={isDisabled}
    >
      {!isDisabled && showCheckmark && (
        <Checkmark data-tip data-for={`client-avatar-${name}`}>
          <FaCheck color={DAVYS_GREY_100} size="0.5rem" />
          <ToolTip id={`client-avatar-${name}`} place="bottom">
            <Support color={DAVYS_GREY_100}>
              Informed Consent has <br /> been discussed
            </Support>
          </ToolTip>
        </Checkmark>
      )}
      {noName ? (
        <Img
          src={NoNameIcon}
          draggable="false"
          alt="default profile icon"
          size={size}
        />
      ) : (
        <Wrapper size={size}>
          {typing ? (
            <FiMoreHorizontal
              size={18}
              strokeWidth={3}
              color={DUSTY_ORANGE_700}
            />
          ) : (
            <Initials size={size}>{initials}</Initials>
          )}
        </Wrapper>
      )}
      {showDot && <Dot />}
    </Container>
  );
};

export default Avatar;
